// extracted by mini-css-extract-plugin
module.exports = {"container":"streamer-slider_container__nNnkl","button":"streamer-slider_button__oDX3R"};